import { Image } from "@/types";

export type WhyUsType = {
  id: number;
  title: string;
  description: string;
  image: Image;
};

export const whyUs: WhyUsType[] = [
  {
    id: 1,
    title: "Security-first planning",
    description:
      "Coverage, access and patrol needs reviewed before recommendations.",
    image: {
      id: 1,
      url: "/images/why-us/why1.svg",
      original: "/images/why-us/why1.svg",
      title: "security planning",
    },
  },
  {
    id: 2,
    title: "CCTV specialists",
    description:
      "Camera positions planned around useful footage and daily operation.",
    image: {
      id: 2,
      url: "/images/why-us/why2.svg",
      original: "/images/why-us/why2.svg",
      title: "cctv systems",
    },
  },
  {
    id: 3,
    title: "Alarm support",
    description:
      "Intruder alarm zones, alerts and maintenance considered together.",
    image: {
      id: 3,
      url: "/images/why-us/why3.svg",
      original: "/images/why-us/why3.svg",
      title: "alarm systems",
    },
  },
  {
    id: 4,
    title: "Access control",
    description: "Card, fob, keypad and entry control for sensitive areas.",
    image: {
      id: 4,
      url: "/images/why-us/why4.svg",
      original: "/images/why-us/why4.svg",
      title: "access control",
    },
  },
  {
    id: 5,
    title: "Guarding and patrols",
    description: "Duties, escalation and reporting matched to the property.",
    image: {
      id: 5,
      url: "/images/why-us/why5.svg",
      original: "/images/why-us/why5.svg",
      title: "security guards",
    },
  },
  {
    id: 6,
    title: "Fire and cabling",
    description:
      "Security infrastructure planned for maintenance and future changes.",
    image: {
      id: 6,
      url: "/images/why-us/why6.svg",
      original: "/images/why-us/why6.svg",
      title: "security cabling",
    },
  },
];
